export const AW_AX_CACHE_DEFAULT = Symbol('awAxCacheDefault');
export const AW_AX_CACHE_SEGMENTATION = Symbol('awAxCacheSegmentation');
